import GPayButton from '@google-pay/button-react';
import { useGooglePay } from '../contexts/GooglePayContext';
import { Site } from '../../generated/graphql';
import { SessionInformation } from '../hooks/useStepHandler';
import { useEffect, useRef } from 'react';
interface GooglePayButtonProps {
  amount: number;
  site: Site | null;
  sessionInformation: SessionInformation;
  setError: (message: string) => void;
  locale: string;
  disabled?: boolean;
  onClick?: (event: Event) => void;
  setGooglePayLoading: (loading: boolean) => void;
}

const environment =
  process.env.REACT_APP_GOOGLE_PAY_ENVIRONMENT === 'production'
    ? 'PRODUCTION'
    : 'TEST';

export const GooglePayButton = ({
  amount,
  site,
  sessionInformation,
  setError,
  locale,
  disabled,
  onClick,
  setGooglePayLoading,
}: GooglePayButtonProps) => {
  const { allowedPaymentMethods, handleGooglePayClick } = useGooglePay();
  const googlePayButtonRef = useRef<any>(null);

  const updateButtonStyle = (
    button?: Element | null,
    disabled?: boolean
  ): void => {
    const cursor = disabled === true ? 'not-allowed' : 'pointer';
    const opacity = disabled === true ? '0.5' : '1';
    const style = `cursor: ${cursor}; opacity: ${opacity}; pointer-events: ${
      disabled === true ? 'none' : 'auto'
    };`;
    button?.setAttribute('style', style);
  };

  useEffect(() => {
    if (
      googlePayButtonRef.current &&
      googlePayButtonRef.current.manager.element
    ) {
      const button =
        googlePayButtonRef.current.manager.element?.querySelector('button') ||
        googlePayButtonRef.current.manager.element.querySelector(
          '[role="button"]'
        ) ||
        googlePayButtonRef.current.manager.element.firstElementChild;
      updateButtonStyle(button, disabled);
    }
  }, [disabled, googlePayButtonRef.current]);

  const handleClick = (event: Event) => {
    if (disabled !== true && onClick !== undefined) {
      onClick(event);
    }
  };

  const handlePaymentData = (paymentData: any) => {
    if (disabled !== true) {
      handleGooglePayClick(
        amount,
        site,
        sessionInformation,
        setError,
        setGooglePayLoading
      )(paymentData);
    }
  };

  return (
    <>
      {allowedPaymentMethods.length > 0 && (
        <GPayButton
          environment={environment}
          buttonType="pay"
          buttonLocale={locale}
          buttonSizeMode="fill"
          ref={googlePayButtonRef}
          onClick={handleClick}
          style={{
            width: '100%',
            height: '85px',
            borderRadius: '10px',
            backgroundColor: '#000',
            color: '#fff',
          }}
          paymentRequest={{
            apiVersion: 2,
            apiVersionMinor: 0,
            allowedPaymentMethods,
            merchantInfo: {
              merchantId: process.env.REACT_APP_GOOGLE_PAY_MERCHANT_ID || '',
              merchantName:
                process.env.REACT_APP_GOOGLE_PAY_MERCHANT_NAME || '',
            },
            transactionInfo: {
              totalPriceStatus: 'FINAL',
              totalPriceLabel: 'Total',
              totalPrice: amount.toFixed(2),
              currencyCode:
                process.env.REACT_APP_GOOGLE_PAY_CURRENCY_CODE || '',
              countryCode: process.env.REACT_APP_GOOGLE_PAY_COUNTRY_CODE || '',
            },
          }}
          onLoadPaymentData={handlePaymentData}
        />
      )}
    </>
  );
};
